/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import popover_animation_type from "src/assets/img/popover_animation_type.svg"
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import AnimatedDelayScalar from "./AnimatedDelayScalar"
import PopoverMulti from "./PopoverMulti"

/* Protopia Ecosystem component */ 
const AnimationTypeScalar = (props: ICompositeWidgetProps): JSX.Element => {
    const setValue = () => {
        
        return {
            animated: !!props.value?.animated 
                ?
                props.value?.animated
                :
                [ ], 
            animated_delay: !!props.value?.animated_delay 
                ?
                props.value?.animated_delay
                :
                !!props.origin?.animated_delay
                    ?
                    props.origin.animated_delay
                    :
                    0
        }
    }
    const _value = useSyncState<any>(setValue())
    useEffect(() => {  
        _value.set(setValue())
    }, [ props.value, props.origin ])
    
    const onTypeChange = (val: any[]) => {
        const value = val.map( (v: any) => v._id )
        _value.set({
            ..._value.get(),
            animated: value
        })
        if(props.onChange) {
            props.onChange(value, "animated", "animated")
        }
    }
    const onDelayChange = (val: any) => {
        _value.set({
            ..._value.get(),
            animated_delay: val
        })
        if(props.onChange) {
            props.onChange(val, "animated_delay", "animated_delay")
        }
    }
    return <div className="pl-2">
        <PopoverMulti 
            subtitle={ "Animation type" }
            values={Object.values( ANIMATED_STYLE ).map(v => ({
                _id:v, 
                title:__(v),
                width:300, 
                height: 40, 
                className: v, 
                img: popover_animation_type 
            }))}
            width={200}
            height={40}
            value={_value.get()?.animated}
            editable={props.editable}
            notClear  
            onSubMenu={props.onSubmenu}  
            onChange={onTypeChange}
        />
        <AnimatedDelayScalar 
            title={ "Animated delay" }
            value={_value.get()?.animated_delay}
            editable={props.editable}  
            onChange={onDelayChange}
            dataSection=""
            dataName="animated_delay"
            type="" 
        />
    </div>
}

export default AnimationTypeScalar